// Importaciones de paquetes
import React, { useEffect, useState, useMemo, useRef } from "react";
import { MaterialReactTable, MRT_TableInstance } from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es";

// Importaciones de componentes
import { BREADCRUMBS } from "../../main_components/pagination/breadcrumbs";
import MODAL_TABLE from "../../main_components/modal/modal_Table";
import RENDER_TOOLBAR_INTERNAL_ACTIONS from "../../main_components/methods_v2/export";

import { MaterialTableContainerProps, RowSelection } from "./interface/interface";

// Componente principal
const MATERIAL_TABLE_CONTAINER: React.FC<MaterialTableContainerProps> = (props) => {
    const [rowSelection, setRowSelection] = useState<RowSelection>({});
    const [pinnedRows, setPinnedRows] = useState<{ top?: string[]; bottom?: string[] }>({});
    const [filteredRowCount, setFilteredRowCount] = useState<number>(props?.data?.length);


    useEffect(() => {
        setRowSelection({});
    }, [props?.data]);

    // 🔍 Filtrar los IDs válidos al momento del render
    const validIds = useMemo(() => props?.data?.map(row => String(row?.id)), [props?.data]);

    const filteredPinnedRows = useMemo(() => ({
        top: pinnedRows.top?.filter(id => validIds.includes(id)),
        bottom: pinnedRows.bottom?.filter(id => validIds.includes(id)),
    }), [pinnedRows, validIds]);

    const columnsWithStartsWith = useMemo(() => {
        return props.columns?.map((col) => ({
            ...col,
            filterFn: col.filterFn || 'startsWith',
        })) || [];
    }, [props.columns]);



    return (
        <div style={{ width: "100%", margin: "0 auto" }} className="new_table_v2">
            {props?.breadcrumbs && <BREADCRUMBS niveles={props?.breadcrumbs} cards_dashboard={true} filter_row={filteredRowCount} total={props?.data?.length} />}

            <MODAL_TABLE
                open={true}
                message={""}
                message2={""}
                modalGeneral={false}
                modalT={props?.modalT}
            />

            <MaterialReactTable
                columns={columnsWithStartsWith}
                data={props?.data}
                // debugTable
                enableGrouping
                enableFacetedValues
                enableStickyHeader
                enableStickyFooter
                enableRowPinning
                enableColumnFilterModes
                enableColumnResizing
                enableColumnPinning
                enableColumnOrdering
                enableExpandAll={false}
                getRowId={(row) => String(row?.id)}
                onRowSelectionChange={setRowSelection}
                onRowPinningChange={setPinnedRows}
                localization={MRT_Localization_ES}
                state={{
                    rowSelection,
                    isLoading: props?.isLoading,
                    rowPinning: filteredPinnedRows,
                }}
                initialState={{
                    showGlobalFilter: true,
                    showColumnFilters: true,
                    columnPinning: {
                        left: props.columns?.some(col => col.id === 'mrt-row-expand') ? ['mrt-row-expand', 'mrt-row-select'] : [],
                    },
                }}
                muiCircularProgressProps={{ color: "secondary", thickness: 5, size: 55 }}
                muiSkeletonProps={{ animation: "pulse", height: 28 }}
                rowVirtualizerOptions={{ overscan: 5 }}
                columnVirtualizerOptions={{ overscan: 2 }}
                muiTableContainerProps={{
                    sx: {
                        maxHeight: props?.maxHeightTable || "69vh",
                        "@media (max-height: 810px)": {
                            maxHeight: props?.maxHeightTable || "65vh",
                        },
                    },
                }}
                muiTablePaperProps={{ sx: { margin: "auto", width: "100%" } }}
                positionToolbarAlertBanner="bottom"
                paginationDisplayMode="pages"
                rowPinningDisplayMode="sticky"
                layoutMode="grid"
                muiTableHeadCellProps={{
                    sx: { flex: "0 0 auto", whiteSpace: "normal !important" },
                }}
                muiTableBodyCellProps={{
                    sx: { flex: "0 0 auto", whiteSpace: "normal !important" },
                }}
                muiPaginationProps={{ color: "primary", shape: "rounded" }}
                displayColumnDefOptions={{
                    "mrt-row-pin": {
                        enableHiding: true,
                        Header: () => props?.component_header,
                    },
                    "mrt-row-expand": {
                        enableHiding: true,
                    },
                    "mrt-row-select": {
                        enableHiding: true,
                    },
                }}
                muiTableBodyRowProps={({ row, table }) => {
                    const { density } = table.getState();
                    return {
                        sx: {
                            height: row.getIsPinned()
                                ? `${density === "compact"
                                    ? 30
                                    : density === "comfortable"
                                        ? 35
                                        : 69}px`
                                : undefined,
                        },
                    };
                }}
                renderTopToolbarCustomActions={() => props?.search_filters}

                renderToolbarInternalActions={({ table }) => {
                    const rowCount = table.getFilteredRowModel()?.rows?.length;
                    if (rowCount !== filteredRowCount) {
                        setFilteredRowCount(rowCount);
                    }
                    return (
                        <RENDER_TOOLBAR_INTERNAL_ACTIONS
                            table={table}
                            file_name={props?.file_name_export}
                            update_identifiers={props?.update_identifiers}
                        />
                    );
                }}
            />
        </div>
    );
};

export default MATERIAL_TABLE_CONTAINER;
